module.exports = __webpack_public_path__ + "img/getup_des_3.8f0ce288.jpg";